import { render, staticRenderFns } from "./HealthCardButton.vue?vue&type=template&id=92c13534&scoped=true&"
import script from "./HealthCardButton.vue?vue&type=script&lang=js&"
export * from "./HealthCardButton.vue?vue&type=script&lang=js&"
import style0 from "./HealthCardButton.vue?vue&type=style&index=0&id=92c13534&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c13534",
  null
  
)

export default component.exports